﻿import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";

const ActivitiesWeeklySummary = {
  fields: {
    showTiles: {
      type: "radio" as const,
      options: [
        { label: "Show", value: true },
        { label: "Hide", value: false },
      ],
    },
    showBars: {
      type: "radio" as const,
      options: [
        { label: "Show", value: true },
        { label: "Hide", value: false },
      ],
    },
  },
  defaultProps: {
    showTiles: true,
    showBars: true,
  },
  render: (props: any) => {
    const { showTiles, showBars } = props as any;
    const {
      dailyLoads,
      weekReport,
      trailingDays,
      maxDaily,
      totalSessionsThisWeek,
      helpers,
    } = useActivitiesData();

    return (
      <div className="activities-card" style={{ padding: "clamp(8px, 2vw, 16px)" }}>
        {showTiles && (
          <div
            className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6"
            style={{ gap: "clamp(8px, calc(0.8svmin + 4px), 16px)" }}
          >
            <div
              className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg p-5 text-white"
              style={{ padding: "clamp(6px, calc(0.8svmin + 4px), 20px)" }}
            >
              <div className="text-2xl font-bold">{totalSessionsThisWeek}</div>
              <div className="text-blue-100">Sessions (7 days)</div>
            </div>

            <div
              className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg p-5 text-white"
              style={{ padding: "clamp(6px, calc(0.8svmin + 4px), 20px)" }}
            >
              <div className="text-2xl font-bold">
                {(weekReport?.weeklyLoad ?? 0).toFixed(0)}
              </div>
              <div className="text-orange-100">Weekly Load (PSS)</div>
              <div className="text-xs text-orange-100 opacity-75 mt-1">
                {helpers.getWeeklyScoreZone(weekReport?.weeklyLoad ?? 0)}
              </div>
            </div>

            <div
              className={`${helpers.gradientClass(
                (weekReport?.monoFlag ?? 0) as any
              )} rounded-lg p-5 text-white`}
              style={{ padding: "clamp(6px, calc(0.8svmin + 4px), 20px)" }}
            >
              <div className="text-2xl font-bold">
                {(weekReport?.monotony ?? 0).toFixed(2)}
              </div>
              <div className="text-amber-100">Monotony</div>
              <div className="text-xs text-amber-100 opacity-75 mt-1">
                {helpers.getMonotonyLabel(weekReport?.monotony ?? 0)}
              </div>
            </div>

            <div
              className={`${helpers.gradientClass(
                (weekReport?.strainFlag ?? 0) as any
              )} rounded-lg p-5 text-white`}
              style={{ padding: "clamp(6px, calc(0.8svmin + 4px), 20px)" }}
            >
              <div className="text-2xl font-bold">
                {(weekReport?.strain ?? 0).toFixed(0)}
              </div>
              <div className="text-white opacity-90">Strain</div>
              <div className="text-xs text-white opacity-80 mt-1">
                {helpers.getStrainLabel(weekReport?.strain ?? 0)}
              </div>
            </div>
          </div>
        )}

        {showBars && (
          <div
            className="rounded-md p-4 border border-gray-200"
            style={{ padding: "clamp(6px, calc(0.8svmin + 6px), 18px)" }}
          >
            <div className="flex items-end justify-between gap-2 h-40">
              {dailyLoads.map((v, i) => {
                const height = Math.round((v / maxDaily) * 100);
                return (
                  <div
                    key={i}
                    className="flex flex-col items-center justify-end w-full"
                  >
                    <div
                      className="w-6 sm:w-8 rounded-t bg-blue-500"
                      style={{ height: `${Math.max(4, height)}%` }}
                      title={`${trailingDays[i].label}: ${v.toFixed(0)} PSS`}
                    />
                    <div className="mt-2 text-xs">
                      {trailingDays[i].label}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  },
};

export default ActivitiesWeeklySummary;
